<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14q0Iae/tc-custom/9780802148254.jpg?1701542632316" alt="This image is the cover for the book Secret Service, The Kate Henderson Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Service, The Kate Henderson Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>An MI6 officer must find a traitor hiding within the highest ranks of government in a new thriller with “resonant echoes of le Carré” (<i>Booklist</i>, starred review).</b><br/><br/> Senior MI6 officer Kate Henderson is in possession of the political equivalent of a nuclear bomb. She heads up the Russia Desk of the Secret Intelligence Service, and one of her undercover operations has revealed some alarming evidence that a senior UK politician is a high-level Russian informer.<br/>  <br/> Determined to find the identity of the traitor, Kate must risk everything to get to the truth. Until a young woman is brutally murdered as a consequence, which puts Kate and her team under the spotlight. With blood on her hands, her reputation to uphold, her family hanging by a thread, and an election looming, Kate is quickly running out of options—and out of time . . .<br/>  <br/> From the author of <i>Shadow Dancer</i> and <i>The White Russian</i>, who has been a finalist for multiple Crime Writers Association awards, this is a tense, timely novel of secrets, betrayals, and spycraft.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Bradby
      </h2>
      
      <p class="authorDescription body article">Tom Bradby is British novelist, screenwriter, and journalist who has written six previous novels that have been bestsellers in the UK.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Atlantic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b6093bd2